/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'DocumentService' store object.
 * @namespace DocumentServiceSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UADocumentService';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof DocumentServiceSelectors
   */
  static postDbsFiles = state => state[selectors.moduleIdentifier].postDbsFiles.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof DocumentServiceSelectors
   */
  static isFetchingPostDbsFiles = state =>
    state[selectors.moduleIdentifier].isFetchingPostDbsFiles.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof DocumentServiceSelectors
   */
  static postDbsFilesError = state => state[selectors.moduleIdentifier].postDbsFilesError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof DocumentServiceSelectors
   */
  static getDbsFilesByFileId = state =>
    state[selectors.moduleIdentifier].getDbsFilesByFileId.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof DocumentServiceSelectors
   */
  static isFetchingGetDbsFilesByFileId = state =>
    state[selectors.moduleIdentifier].isFetchingGetDbsFilesByFileId.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof DocumentServiceSelectors
   */
  static getDbsFilesByFileIdError = state =>
    state[selectors.moduleIdentifier].getDbsFilesByFileIdError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof DocumentServiceSelectors
   */
  static deleteDbsFilesByFileId = state =>
    state[selectors.moduleIdentifier].deleteDbsFilesByFileId.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof DocumentServiceSelectors
   */
  static isFetchingDeleteDbsFilesByFileId = state =>
    state[selectors.moduleIdentifier].isFetchingDeleteDbsFilesByFileId.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof DocumentServiceSelectors
   */
  static deleteDbsFilesByFileIdError = state =>
    state[selectors.moduleIdentifier].deleteDbsFilesByFileIdError.payload;
}
